import cn from 'classnames';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import Image from 'next/image';
import { useState } from 'react';
import { useMedia } from 'react-use';

const Slider = ({ slides = [] }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const isDesktop = useMedia('(min-width: 1024px)');
  const [sliderRef, slider] = useKeenSlider({
    loop: false,
    drag: !isDesktop,
    slides: {
      perView: 1,
      spacing: 16
    },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel);
    },
    created() {
      setLoaded(true);
    }
  });

  return (
    <div className="mb-6">
      <div ref={sliderRef} className="relative keen-slider">
        {loaded && slider.current && (
          <>
            <button
              onClick={() => slider.current?.prev()}
              className="absolute z-10 hidden w-10 h-10 transition-colors duration-200 -translate-y-1/2 rounded-full bg-neutral-950 not:disabled:hover:bg-black lg:block disabled:cursor-not-allowed disabled:opacity-60 focus:outline-white not:disabled:focus:outline-1 focus:outline-offset-1 left-4 top-1/2"
              type="button"
              disabled={currentSlide === 0}
            >
              {'<-'}
            </button>
            <button
              onClick={() => slider.current?.next()}
              className="absolute z-10 hidden w-10 h-10 transition-colors duration-200 -translate-y-1/2 rounded-full bg-neutral-950 not:disabled:hover:bg-black lg:block disabled:cursor-not-allowed disabled:opacity-60 focus:outline-white not:disabled:focus:outline-1 focus:outline-offset-1 right-4 top-1/2"
              type="button"
              disabled={currentSlide === slides.length - 1}
            >
              {'->'}
            </button>
          </>
        )}
        {slides.map((slide, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} className="flex keen-slider__slide">
            <Image
              unoptimized
              src={slide.src}
              alt={slide.alt}
              width={slide.width}
              height={slide.height}
              layout="intrinsic"
              quality={100}
            />
          </div>
        ))}
      </div>
      {loaded && slider && (
        <div className="flex justify-center mx-auto mt-6 space-x-2 max-w-max lg:hidden">
          {[...Array(slider.current.slides.length).keys()].map(idx => (
            <span
              key={idx}
              onClick={() => slider.current?.moveToIdx(idx)}
              className={cn(
                'cursor-pointer rounded-full w-2 h-2',
                currentSlide === idx ? 'bg-white' : 'bg-plain-neutral-4'
              )}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Slider;
